import { globalStyObj } from '@/assets/packageAssets/global-cfg.js'

const styObj = {
  // 局部样式变量示例
  vava: {
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/not-check.png')})`,
    '--icon-tag-bg': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/tag-bg.png')})`,
    '--icon-trangle': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/trangle.png')})`
  },
  echo: {
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/not-check.png')})`,
    '--icon-tag-bg': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/tag-bg.png')})`,
    '--icon-trangle': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/trangle.png')})`
  },
  joychat: {
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/not-check.png')})`,
    '--icon-tag-bg': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/tag-bg.png')})`,
    '--icon-trangle': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/trangle.png')})`
  },
  kiko: {
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/not-check.png')})`,
    '--icon-tag-bg': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/tag-bg.png')})`,
    '--icon-trangle': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vava/trangle.png')})`
  }
}

export const pageCssVars = {
  methods: {
    cssVars () {
      if (this.packageName && styObj[this.packageName]) {
        // 全局 + 局部包
        return { ...globalStyObj, ...styObj[this.packageName] }
      }
      return {}
    }
  }
}
